module.exports = __webpack_public_path__ + "images/block_diagrams.png?v=2febf3573007f65f411393d42e6d2ab7";